import * as React from "react";
import { localedFormat } from "../../../utils";
import IconButton from "@material-ui/core/IconButton";
import Select from "@material-ui/core/Select";
import ArrowLeft from "@material-ui/icons/NavigateBefore";
import ArrowRight from "@material-ui/icons/NavigateNext";
import "./Header.css";
import { startOfYear, addYears } from "date-fns";
import MenuItem from "@material-ui/core/MenuItem";
import LinearProgress from "@material-ui/core/LinearProgress";
import MediaQuery from "react-responsive";
import { Button } from "@material-ui/core";

interface Props {
	date: Date;
	changeDate: (date: Date) => void;
	headerText?: string;
	isLoading?: boolean;
}

const CalendarHeader: React.FunctionComponent<Props> = (props) => {
	const onDateChange = (dir: "back" | "next") => {
		const date = startOfYear(props.date);

		props.changeDate(addYears(date, dir === "back" ? -1 : 1));
	};

	const forceToOld = localStorage.getItem("calendarForceOld") === "true";

	const onForceToOld = () => {
		localStorage.setItem("calendarForceOld", forceToOld ? "false" : "true");

		window.location.reload();
	};

	return (
		<div className="calendar-header">
			{props.isLoading && (
				<div className="calendar-header__loading">
					<LinearProgress />
				</div>
			)}

			<div className="calendar-header__currentYear">
				<IconButton onClick={() => onDateChange("back")}>
					<ArrowLeft />
				</IconButton>

				<IconButton onClick={() => onDateChange("next")}>
					<ArrowRight />
				</IconButton>

				{props.headerText
					? props.headerText
					: localedFormat(props.date, "yyyy")}
			</div>

			<MediaQuery maxWidth={1025} minWidth={600}>
				<Button onClick={onForceToOld}>
					{forceToOld ? "На новую версию" : "На старую версию"}
				</Button>
			</MediaQuery>
		</div>
	);
};

export default CalendarHeader;
